import { Config } from 'modules/config/state/config-types'
import { FlowSlice, FlowStep, FlowSteps } from '../flow-types'
import { URLParams } from 'modules/url-params/state/app-url-params-types'
import { DONATION_GRID_STEP_NAME, makeDonationGridStep } from './steps/donation-grid'
import makeRecurringNudgeStep, { RECURRING_NUDGE_STEP_NAME } from './steps/recurring-nudge'
import makePaymentMethodsStep, { PAYMENT_METHODS_STEP_NAME } from './steps/payment-method'
import makeCardDetailsStep from './steps/card-details'
import makeBankDetailsStep from './steps/bank-details'
import makeOptionsStep from './steps/options'
import makeDonorInformationStep from './steps/donor-information'
import { makeAdditionalDonorInformationStep } from './steps/additional-donor-information'
import { makeDesignationStep } from './steps/designation'
import { makeDedicationSteps } from './steps/dedication'
import makeDoubleTheDonationStep from './steps/double-the-donation'
import makeCustomQuestionSteps from './steps/custom-questions'
import makeCommentStep from './steps/comment'
import { makeThankYouStep } from './steps/thank-you'
import makeDCFNudgeStep from './steps/dcf-nudge'
import makeDonationStep, { DONATION_STEP_NAME } from './steps/donation-step.utils'
import makePaymentStep from './steps/payment-step.utils'
import makeDonorStep from './steps/donor-step.utils'
import makeDedicationStep from './steps/dedication-step.utils'

const makeFlowInitialState = (config: Config, urlParams: URLParams): FlowSlice => {
  let stepsArr: FlowStep[] = []

  if (config.isEmbedded) {
    stepsArr = [
      makeDonationGridStep(),
      makeRecurringNudgeStep(config, urlParams),
      makePaymentMethodsStep(),
      makeCardDetailsStep(),
      makeBankDetailsStep(),
      makeDCFNudgeStep(config),
      makeOptionsStep(config),
      ...makeCustomQuestionSteps(config, true),
      makeDonorInformationStep(),
      makeAdditionalDonorInformationStep(config),
      makeDesignationStep(config),
      ...makeDedicationSteps(config),
      makeDoubleTheDonationStep(config),
      ...makeCustomQuestionSteps(config, false),
      makeCommentStep(config),
      makeThankYouStep(),
    ]
  } else {
    stepsArr = [
      makeDonationStep(),
      makePaymentStep(),
      makeDonorStep(config),
      makeDedicationStep(config),
    ]
  }

  const stepsMap = stepsArr.reduce((acc, cur, index) => {
    const step: FlowStep = {
      ...cur,
      index, // IMPORTANT: Override the default index of -1
    }

    return { ...acc, [step.name]: step }
  }, {} as FlowSteps)

  const initialStepName = config.isEmbedded
    ? makeEmbeddedInitialStepName(urlParams, stepsMap)
    : makeInitialStepName()

  const currentStep = stepsMap[initialStepName]
  currentStep.numVisits = 1

  return {
    stepsMap,
    currentStepName: initialStepName,
  }
}

export default makeFlowInitialState

const makeEmbeddedInitialStepName = (urlParams: URLParams, stepsMap: FlowSteps) => {
  const { frequency, amount } = urlParams

  if (!frequency || !amount) {
    return DONATION_GRID_STEP_NAME
  }

  if (stepsMap[RECURRING_NUDGE_STEP_NAME].enabled) {
    return RECURRING_NUDGE_STEP_NAME
  }

  return PAYMENT_METHODS_STEP_NAME
}

/**
 * TODO: This is where we decide to show the single vs donation/payment steps in pre-conversion
 */
const makeInitialStepName = () => {
  return DONATION_STEP_NAME
}
